module.exports = __webpack_public_path__ + "static/img/IMG_20170525_135233.92e3330c.jpg";